import { useGlobalSearchParams, useLocalSearchParams } from "expo-router";

// TODO: remove this hook and use useGlobalSearchParams inside the layout.
// This is wrong! We need to remove this incorrect hook.
export function useRouterSearchParams(
  parameterName: string,
  defaultValue?: string,
): string {
  const globalParameters = useGlobalSearchParams();
  const localParameters = useLocalSearchParams();

  // Merge global and local parameters, prioritizing local parameters
  const parameters = { ...globalParameters, ...localParameters };
  const parameterValue = parameters[parameterName];

  if (Array.isArray(parameterValue)) {
    return parameterValue[0] ?? "";
  } else if (typeof parameterValue === "string") {
    return parameterValue;
  } else {
    if (defaultValue !== undefined && defaultValue !== null) {
      return defaultValue;
    } else {
      return "";
    }
  }
}
